<template>
  <div class="container pt-100 pb-70">
    <div class="row">
      <div class="col-lg-4 offset-lg-0 col-md-10 offset-md-1">
        <div class="portfolio-card">
          <router-link to="/portfolio-details">
            <img
              src="../../assets/img/portfolio/portfolio-1.webp"
              alt="Image"
            />
          </router-link>
          <h3 class="fs-26">
            <router-link to="/portfolio-details">
              Mockup & Branding Design
            </router-link>
          </h3>
          <span>Branding</span>
        </div>
        <div class="portfolio-card">
          <router-link to="/portfolio-details">
            <img
              src="../../assets/img/portfolio/portfolio-4.webp"
              alt="Image"
            />
          </router-link>
          <h3 class="fs-26">
            <router-link to="/portfolio-details">
              Book & Cover Design
            </router-link>
          </h3>
          <span>Design</span>
        </div>
        <div class="portfolio-card">
          <router-link to="/portfolio-details">
            <img
              src="../../assets/img/portfolio/portfolio-6.webp"
              alt="Image"
            />
          </router-link>
          <h3 class="fs-26">
            <router-link to="/portfolio-details">
              Strategic Planning
            </router-link>
          </h3>
          <span>Planning</span>
        </div>
      </div>
      <div class="col-lg-4 offset-lg-0 col-md-10 offset-md-1">
        <div class="portfolio-card">
          <router-link to="/portfolio-details">
            <img
              src="../../assets/img/portfolio/portfolio-2.webp"
              alt="Image"
            />
          </router-link>
          <h3 class="fs-26">
            <router-link to="/portfolio-details">
              Strategic Planning
            </router-link>
          </h3>
          <span>Design</span>
        </div>
        <div class="portfolio-card">
          <router-link to="/portfolio-details">
            <img
              src="../../assets/img/portfolio/portfolio-7.webp"
              alt="Image"
            />
          </router-link>
          <h3 class="fs-26">
            <router-link to="/portfolio-details">
              Strategic Planning
            </router-link>
          </h3>
          <span>Design</span>
        </div>
      </div>
      <div class="col-lg-4 offset-lg-0 col-md-10 offset-md-1">
        <div class="portfolio-card">
          <router-link to="/portfolio-details">
            <img
              src="../../assets/img/portfolio/portfolio-3.webp"
              alt="Image"
            />
          </router-link>
          <h3 class="fs-26">
            <router-link to="/portfolio-details">Mockup Design</router-link>
          </h3>
          <span>Graphic</span>
        </div>
        <div class="portfolio-card">
          <router-link to="/portfolio-details">
            <img
              src="../../assets/img/portfolio/portfolio-5.webp"
              alt="Image"
            />
          </router-link>
          <h3 class="fs-26">
            <router-link to="/portfolio-details">Branding Identity</router-link>
          </h3>
          <span>Branding</span>
        </div>
        <div class="portfolio-card">
          <router-link to="/portfolio-details">
            <img
              src="../../assets/img/portfolio/portfolio-8.webp"
              alt="Image"
            />
          </router-link>
          <h3 class="fs-26">
            <router-link to="/portfolio-details">Branding Identity</router-link>
          </h3>
          <span>Branding</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PortfolioContent",
};
</script>

<style lang="scss" scoped>
.portfolio-card {
  margin: 0 0 30px;
  img {
    border-radius: 6px;
  }
  h3 {
    margin: 25px 0 3px;
  }
}
</style>